import { render } from "./Prix.vue?vue&type=template&id=cfa6aeb0"
import script from "./Prix.vue?vue&type=script&lang=js"
export * from "./Prix.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__